import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';

import css from './BooksCalendarButton.module.scss';

interface Props extends React.ComponentProps<'button'> {
  disabled?: boolean;
  customType: string;
  onClick?: () => void;
}

const BooksCalendarButton = ({
  customType,
  disabled,
  onClick,
  ...attr
}: Props) => {
  const classes = classNames(css.BooksCalendarButton, {
    [css.isNext]: customType === 'next',
    [css.isPrev]: customType === 'prev',
    [css.isToday]: customType === 'today',
  });
  const intl = useIntl();

  return (
    <button {...attr} className={classes} disabled={disabled} onClick={onClick}>
      {customType === 'today' &&
        intl.formatMessage({ id: 'books.calendar.today' })}
    </button>
  );
};

export default BooksCalendarButton;
